export default __webpack_public_path__ + "static/media/icon-filter-white.2e7da6e2.svg";